import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const SvgTypeFa = (props: SvgProps) => (
  <Svg width={24} height={24} viewBox="0 0 70 21" fill="none" {...props}>
    <Path
      d="M64.877 17.841a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM68.426 17.765a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#00469F"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.32 11.206V5.36c-.996 0-2.4 1.659-2.4 1.659v3.369c0 1.225-1.226 1.225-1.226 1.225H60.79V5.08l-4.545.051s-3.907.587-3.907 4.39 3.09 3.93 3.09 3.93h1.991c.766 0 .868.026.868.537 0 .51-1.098 1.99-3.09 2.399-.178.612.64 1.556 1.073 1.48 3.345-.664 4.341-3.471 4.341-3.956a.46.46 0 0 1 .46-.46h5.515c2.733 0 2.733-2.245 2.733-2.245Zm-11.031.408V6.356h-1.251c-.332 0-2.17.434-2.17 2.629 0 2.756 1.736 2.629 1.736 2.629h1.685Z"
      fill="#00469F"
    />
    <Path
      d="M44.5 3.804a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM48.049 3.727a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#00469F"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.964 11.206V5.36c-.996 0-2.4 1.659-2.4 1.659v3.369c0 1.225-1.226 1.225-1.226 1.225h-4.903V5.08l-4.545.051s-3.907.587-3.907 4.39 3.09 3.93 3.09 3.93h1.992c.766 0 .842.026.842.537 0 .51-1.072 1.99-3.064 2.399-.179.612.638 1.556 1.072 1.48 3.346-.664 4.316-3.497 4.316-3.956 0-.46.485-.46.485-.46h5.516c2.732 0 2.732-2.245 2.732-2.245Zm-11.056.408V6.356h-1.226c-.332 0-2.17.434-2.17 2.629 0 2.756 1.736 2.629 1.736 2.629h1.66Z"
      fill="#00469F"
    />
    <Path
      d="M28.106 5.897s1.506-1.276 2.707 0c.102.102.076 4.951.076 4.951s0 2.4-2.553 2.4H21.44s-.791-.077-.791-.46c0 0-.358.46-.74.46h-6.998s-.766 4.21-6.23 4.21c-5.465 0-6.512-1.48-6.512-9.443h2.477v3.829s.332 4.338 3.882 4.338c3.55 0 3.932-4.313 3.932-4.313V6.356s.639-1.225 2.375-1.225v5.002s.204 1.328 1.353 1.328h3.984s1.2.102 1.2-1.328V6.024a1.839 1.839 0 0 1 2.451 0v4.365a1.352 1.352 0 0 0 1.354 1.072h4.136s.869-.077.869-.868-.077-4.696-.077-4.696ZM26.523 17.663a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM30.072 17.56a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.809Z"
      fill="#1C95A2"
    />
    <Path
      d="M16.258 17.612a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM19.807 17.535a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM6.477 9.649a1.404 1.404 0 1 0 .001-2.809 1.404 1.404 0 0 0 0 2.809ZM28.285 20.7a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#1C95A2"
    />
    <Path d="M18.48 16.106h-.869v.16h.868v-.16Z" fill="#1C95A2" />
  </Svg>
);

export default SvgTypeFa;
